var _style, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStrongTstorms(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "Layer_1",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 32 32"
    },
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st2{fill-rule:evenodd;clip-rule:evenodd;fill:#5285eb}")), /*#__PURE__*/React.createElement("g", {
    id: "Sun-_x26_-Cloud_11_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Combined-Shape_6_",
    cx: 16.751,
    cy: 9.927,
    r: 9.656,
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#f1f3f4"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Oval_5_",
    x1: -525.973,
    x2: -525.35,
    y1: 426.73,
    y2: 425.943,
    gradientTransform: "matrix(24 0 0 -24 12635 10245)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f1f3f4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#dedfdf"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval_18_",
    cx: 16.751,
    cy: 9.927,
    r: 9.656,
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Oval_5_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Oval_8_",
    x1: -520.712,
    x2: -521.115,
    y1: 390.144,
    y2: 390.144,
    gradientTransform: "matrix(20 0 0 -10 10431 3917)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f1f3f4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Oval_17_",
    d: "M16.751 19.583a8.047 8.047 0 0 0-16.094 0c.012-.018 16.098-.012 16.094 0z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#Oval_8_)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill-1_3_",
    d: "m21.615 9.489-4.864 10.097h4.377l-.542 8.985 10.757-11.77-3.893-.016 3.893-7.296z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#fbbc04"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape-Copy-6_9_",
    d: "m3.221 24.176 1.82-1.82 1.82 1.82a2.575 2.575 0 1 1-3.64 0z",
    className: "st2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape-Copy-6_8_",
    d: "m10.546 24.176 1.82-1.82 1.82 1.82a2.575 2.575 0 1 1-3.64 0z",
    className: "st2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrongTstorms);
export default __webpack_public_path__ + "static/media/strong_tstorms.d450e88371e355899cf78bd6d22560a5.svg";
export { ForwardRef as ReactComponent };